import {memo} from 'react';

import type {SVGProps} from 'react';

export const ComplianceIcon = memo(function ComplianceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M15.4167 7.08333H11.25L9.20833 5.375C8.91667 5.125 8.5 5 8.125 5H5C4.33333 5 3.75 5.58333 3.75 6.29167V11.2917V14.1667V17.0833C3.75 17.7917 4.33333 18.375 5.04167 18.375H18.3333C19.0417 18.375 19.625 17.7917 19.625 17.0833V8.375C19.625 7.66667 19.0417 7.08333 18.3333 7.08333H17.875H15.4167Z"
          fill="var(--icon-fill-yellow)"
        />
        <path
          d="M2.29199 12.4167V15.2083C2.29199 15.9167 2.83366 16.4583 3.54199 16.4583H16.4587C17.167 16.4583 17.7087 15.9167 17.7087 15.2083V6.875C17.7087 6.16667 17.167 5.625 16.4587 5.625H16.0003"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6253 5.62484H9.79199L7.75033 3.9165C7.45866 3.6665 7.08366 3.5415 6.66699 3.5415H3.54199C2.83366 3.5415 2.29199 4.08317 2.29199 4.7915V9.6665"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 6.87516H7.54167C7.91667 6.87516 8.29167 6.75016 8.625 6.50016L9.58333 5.7085"
          stroke="var(--icon-stroke-yellow)"
          strokeWidth={1.25}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
